<script setup>
import { useI18n } from "vue-i18n";
import { useForm } from "@/form";
import { FormInput, FormListbox, FormSection, FormTextarea } from "@Components/Form";
import { PrimaryButton } from "@Components/Button";

const { t: __ } = useI18n();

const settings = await useForm().post("settings_amazon_index");

const form = useForm({
    affiliate_id: settings.affiliate_id,
    store: settings.store,
});

const submit = () => {
    form.post("settings_amazon_update");
};

const stores = [
    {
        id: "us",
        name: __("États-Unis"),
    },
    {
        id: "ca",
        name: __("Canada"),
    },
    {
        id: "mx",
        name: __("Mexique"),
    },
    {
        id: "br",
        name: __("Brésil"),
    },

    {
        id: "uk",
        name: __("Royaume-Uni"),
    },
    {
        id: "de",
        name: __("Allemagne"),
    },
    {
        id: "fr",
        name: __("France"),
    },
    {
        id: "it",
        name: __("Italie"),
    },
    {
        id: "es",
        name: __("Espagne"),
    },
    {
        id: "nl",
        name: __("Pays-Bas"),
    },
    {
        id: "se",
        name: __("Suède"),
    },
    {
        id: "pl",
        name: __("Pologne"),
    },
    {
        id: "be",
        name: __("Belgique"),
    },
    {
        id: "ie",
        name: __("Irlande"),
    },

    {
        id: "ae",
        name: __("Émirats Arabes Unis"),
    },
    {
        id: "sa",
        name: __("Arabie Saoudite"),
    },
    {
        id: "eg",
        name: __("Égypte"),
    },
    {
        id: "tr",
        name: __("Turquie"),
    },
    {
        id: "za",
        name: __("Afrique du Sud"),
    },

    {
        id: "jp",
        name: __("Japon"),
    },
    {
        id: "in",
        name: __("Inde"),
    },
    {
        id: "sg",
        name: __("Singapour"),
    },
    {
        id: "au",
        name: __("Australie"),
    },
];
</script>
<template>
    <div class="divide-y divide-gray-300 dark:divide-gray-800">
        <FormSection @submitted="submit">
            <template #title> {{ __("Amazon") }} </template>
            <template #description>
                {{ __("Amazon Affiliate vous permet de générer des revenus en ajoutant des produits Amazon dans vos contenus.") }}
            </template>

            <template #form>
                <div class="sm:col-span-full">
                    <FormInput v-model="form.affiliate_id" :label="__('Affiliate ID')" :errors="form.errors.get('affiliate_id')" />
                </div>
                <div class="sm:col-span-3">
                    <FormListbox :label="__('Store')" :items="stores" v-model="form.store" :errors="form.errors.get('store')" required />
                </div>
            </template>

            <template #actions>
                <div class="flex justify-end items-center">
                    <PrimaryButton :processing="form.processing" :success="form.recentlySuccessful"> {{ __("Sauvegarder") }} </PrimaryButton>
                </div>
            </template>
        </FormSection>
    </div>
</template>
